"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.number.constructor");
var _pushConfig = _interopRequireDefault(require("./pushConfig.vue"));
var _pushSwitch = _interopRequireDefault(require("./pushSwitch.vue"));
var _pushHuaWeiConfig = _interopRequireDefault(require("./pushHuaWeiConfig.vue"));
var _pushXiaoMiConfig = _interopRequireDefault(require("./pushXiaoMiConfig.vue"));
var _pushVivoConfig = _interopRequireDefault(require("./pushVivoConfig.vue"));
var _pushHonorConfig = _interopRequireDefault(require("./pushHonorConfig.vue"));
var _pushOppoConfig = _interopRequireDefault(require("./pushOppoConfig.vue"));
var _threePartyConfiguration = require("@/api/appBasicSetup/threePartyConfiguration");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  components: {
    pushConfig: _pushConfig.default,
    pushSwitch: _pushSwitch.default,
    pushHuaWeiConfig: _pushHuaWeiConfig.default,
    pushXiaoMiConfig: _pushXiaoMiConfig.default,
    pushVivoConfig: _pushVivoConfig.default,
    pushHonorConfig: _pushHonorConfig.default,
    pushOppoConfig: _pushOppoConfig.default
  },
  data: function data() {
    return {
      loading: false,
      activeVendor: 'huawei',
      jguangBaseConfig: {},
      huaweiConfig: {},
      oppoConfig: {},
      xiaomiConfig: {},
      vivoConfig: {},
      honorConfig: {}
    };
  },
  computed: {
    // 激活的渠道 1：极光（默认） 2：袤博
    activMode: function activMode() {
      return Number(this.jguangBaseConfig.activMode) || 1;
    },
    channelName: function channelName() {
      return this.activMode === 2 ? 'Mob Tech' : '极光推送';
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;
      this.loading = true;
      (0, _threePartyConfiguration.queryThirdConfig)({
        type: 1
      }).then(function (res) {
        _this.loading = false;
        var jigangConfig = res.data && res.data.jigangConfig || {};
        _this.jguangBaseConfig = jigangConfig.jguangBaseConfig || {};
        _this.huaweiConfig = jigangConfig.huaweiConfig || {};
        _this.oppoConfig = jigangConfig.oppoConfig || {};
        _this.xiaomiConfig = jigangConfig.xiaomiConfig || {};
        _this.vivoConfig = jigangConfig.vivoConfig || {};
        _this.honorConfig = jigangConfig.honorConfig || {};
      }).catch(function () {
        _this.loading = false;
      });
    },
    // 切换推送服务商（立即生效，无需重新打包）
    onSelectChannel: function () {
      var _onSelectChannel = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(mode) {
        var _t, _t2;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (!(this.activMode === mode)) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _context.p = 1;
              _context.n = 2;
              return this.$confirm("\u786E\u8BA4\u5C06\u63A8\u9001\u670D\u52A1\u5546\u5207\u6362\u4E3A".concat(mode === 1 ? '极光推送' : 'Mob Tech', "\uFF1F\u5207\u6362\u540E\u7ACB\u5373\u751F\u6548\u3002"), '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              });
            case 2:
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              return _context.a(2);
            case 4:
              _context.p = 4;
              _context.n = 5;
              return (0, _threePartyConfiguration.thirdConfig)({
                type: 1,
                jigangConfig: {
                  type: 0,
                  jguangBaseConfig: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.jguangBaseConfig), {}, {
                    activMode: mode
                  })
                }
              });
            case 5:
              this.jguangBaseConfig = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.jguangBaseConfig), {}, {
                activMode: mode
              });
              this.$notify.success({
                title: '温馨提示',
                message: '切换成功！'
              });
              _context.n = 7;
              break;
            case 6:
              _context.p = 6;
              _t2 = _context.v;
              console.log(_t2);
            case 7:
              return _context.a(2);
          }
        }, _callee, this, [[4, 6], [1, 3]]);
      }));
      function onSelectChannel(_x) {
        return _onSelectChannel.apply(this, arguments);
      }
      return onSelectChannel;
    }(),
    jump: function jump(val) {
      window.open(val);
    }
  }
};